import GrupoService from "@/api/services/cobranza/nomencladores/GrupoService"
import GradoService from "@/api/services/cobranza/nomencladores/GradoService"
import Vue from "vue"

const state = () => ({
    grupos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    GRUPOS: state => {
        return state.grupos
    },
    GRUPOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_GRUPOS: (state, payload) => {
        state.grupos = payload
    },

    SET_GRUPOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_GRUPO: (state, payload) => {
        state.grupos.push(payload)
    },

    UPDATE_GRUPO: (state, payload) => {
        state.grupos = state.grupos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_GRUPO: (state, payload) => {
        state.grupos = state.grupos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_GRUPOS: async ({ commit, state }, { gradoID, filter, grupoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await GrupoService.get({ gradoID, filter, grupoEstado, ...pagination })
            if (status === 200) {
                commit("SET_GRUPOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grupos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_GRUPOS: async ({ commit }) => {
        try {
            let { data, status } = await GrupoService.getAll()
            if (status === 200) {
                commit("SET_GRUPOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_GRADO_DETAILS_GRUPOS: async ({ commit }, payload) => {
        try {
            let { data, status } = await GradoService.getGradoDetails(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los datos del grado proveniente, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_RECORDS_GRUPOS: async ({ commit }) => {
        try {
            let { data, status } = await GrupoService.getAllRecords()
            if (status === 200) {
                commit("SET_GRUPOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los grupos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_GRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_GRUPO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del grupo, inténtelo nuevamente"
            })
        }
    },

    ADD_GRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoService.post(payload)
            if (status === 201) {
                commit("ADD_GRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El grupo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el grupo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_GRUPO: async ({ commit }, payload) => {
        try {
            let { data, status } = await GrupoService.put(payload)
            if (status === 200) {
                commit("UPDATE_GRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El grupo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el grupo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_GRUPO: async ({ commit }, payload) => {
        try {
            let { status, data } = await GrupoService.delete(payload)
            if (status === 204) {
                commit("DELETE_GRUPO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El grupo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_GRUPO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El grupo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el grupo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
